// Structured page content per language.
// NL = source of truth; DE/EN provided; fallback to NL if key missing.
// [NOG AANVULLEN]-placeholders staan als __PLACEHOLDER__ zodat we ze
// als "Info volgt"/"Coming soon"-pill kunnen renderen.
export const P = "__PLACEHOLDER__";

const home = {
  nl: {
    hero: {
      eyebrow: "Aan het IJsselmeer · Friesland",
      title: "Welkom in Lemmer",
      subtitle: "Ontdek wat Lemmer te bieden heeft.",
      ctaTodo: "Wat is er te doen?",
      ctaGuide: "Bekijk de bedrijvengids",
    },
    intro: {
      eyebrow: "Ons watersportdorp",
      title: "Lemmer, aan het water",
      p1: "Lemmer ligt aan het IJsselmeer, precies waar Friesland het water raakt. Een levendige haven, gezellige terrassen langs 't Dok en een centrum waar je zo een middag zoekraakt.",
      p2: "Van een rondje varen op het water tot een bezoek aan het Werelderfgoed Woudagemaal: in Lemmer beleef je Friesland op zijn mooist. Welkom bij ons.",
    },
    categories: {
      eyebrow: "Ontdek Lemmer",
      title: "Waar begin je?",
      intro: "Van winkelen en een hapje eten tot een dag op het water.",
      items: {
        "eten-drinken": { title: "Eten & Drinken", intro: "Terrasjes, visrestaurants en gezellige cafés" },
        winkelen: { title: "Winkelen", intro: "Sfeervolle winkels in het centrum" },
        mode: { title: "Mode", intro: "Boetieks, schoenen en accessoires" },
        "wonen-interieur": { title: "Wonen & Interieur", intro: "Inspiratie voor thuis, van meubels tot decoratie" },
        "gezondheid-beauty": { title: "Gezondheid & Beauty", intro: "Kappers, wellness en zorg voor jezelf" },
        diensten: { title: "Diensten", intro: "Vakmensen en zakelijke dienstverlening" },
        overnachten: { title: "Overnachten", intro: "Hotels, B&B's, campings en vakantiehuizen" },
        "cultuur-vrije-tijd": { title: "Cultuur & Vrije tijd", intro: "Musea, activiteiten en evenementen" },
      },
    },
    highlights: {
      eyebrow: "Uitgelicht",
      title: "Niet te missen in Lemmer",
      items: {
        woudagemaal: {
          title: "Woudagemaal",
          tag: "UNESCO Werelderfgoed",
          intro: "Het grootste nog werkende stoomgemaal ter wereld. Een indrukwekkend stukje Nederlandse waterbouwkunde, vlakbij Lemmer.",
        },
        dok: {
          title: "Het Dok",
          tag: "Historisch centrum",
          intro: "De bruisende kern van Lemmer met sluis, terrasjes en boten. Ga zitten met een kop koffie en kijk hoe de schepen voorbijvaren.",
        },
        watersport: {
          title: "Watersport op het IJsselmeer",
          tag: "Aan het water",
          intro: "Zeilen, sup'en of een dagje varen. Lemmer is dé uitvalsbasis voor watersport op het IJsselmeer en de Friese meren.",
        },
      },
    },
    agenda: {
      eyebrow: "Agenda",
      title: "Wat is er te doen?",
      intro: "De eerstvolgende evenementen in Lemmer. Zet ze vast in je agenda.",
    },
    cta: {
      badge: "Voor ondernemers",
      title1: "Ondernemer in Lemmer?",
      title2: "Laat je bedrijf zien op Lemmer Leeft.",
      body: "Zet je bedrijf op de kaart bij inwoners, bezoekers, watersporters en vakantiegangers. Meld je aan en laat zien wat jij in Lemmer doet.",
      button: "Meld je bedrijf aan",
    },
    seo: {
      title: "Lemmer Leeft — Ontdek wat Lemmer te bieden heeft",
      description: "Het online bezoekersportaal van Lemmer. Ontdek eten & drinken, winkels, watersport, evenementen en meer in dit Friese watersportdorp.",
    },
  },
  de: {
    hero: {
      eyebrow: "Am IJsselmeer · Friesland",
      title: "Willkommen in Lemmer",
      subtitle: "Entdecken Sie, was Lemmer zu bieten hat.",
      ctaTodo: "Was gibt es zu erleben?",
      ctaGuide: "Zum Firmenverzeichnis",
    },
    intro: {
      eyebrow: "Unser Wassersportdorf",
      title: "Lemmer, am Wasser",
      p1: "Am Wasser, mit einem gemütlichen Zentrum und weltberühmtem Erbe: In Lemmer gibt es mehr zu erleben, als Sie denken. Ob Sie im Hafen anlegen, einen Tag am Wasser schlendern oder länger in der Umgebung bleiben, hier fühlen Sie sich willkommen.",
      p2: "Von einer Bootstour bis zum Besuch des Welterbes Woudagemaal: In Lemmer erleben Sie Friesland von seiner schönsten Seite. Willkommen bei uns.",
    },
    categories: {
      eyebrow: "Lemmer entdecken",
      title: "Wo fangen Sie an?",
      intro: "Wählen Sie eine Kategorie und tauchen Sie ein. Von einem Bissen zu essen bis zu einem Tag auf dem Wasser.",
      items: {
        "eten-drinken": { title: "Essen & Trinken", intro: "Terrassen, Fischrestaurants und gemütliche Cafés" },
        winkelen: { title: "Einkaufen", intro: "Stimmungsvolle Geschäfte im Zentrum" },
        mode: { title: "Mode", intro: "Boutiquen, Schuhe und Accessoires" },
        "wonen-interieur": { title: "Wohnen & Interieur", intro: "Inspiration für zu Hause – Möbel und Dekoration" },
        "gezondheid-beauty": { title: "Gesundheit & Beauty", intro: "Friseur, Wellness und Selbstpflege" },
        diensten: { title: "Dienstleistungen", intro: "Handwerker und geschäftliche Dienste" },
        overnachten: { title: "Übernachten", intro: "Hotels, B&Bs, Campingplätze und Ferienhäuser" },
        "cultuur-vrije-tijd": { title: "Kultur & Freizeit", intro: "Museen, Aktivitäten und Veranstaltungen" },
      },
    },
    highlights: {
      eyebrow: "Hervorgehoben",
      title: "Nicht verpassen in Lemmer",
      items: {
        woudagemaal: {
          title: "Das Woudagemaal",
          tag: "UNESCO-Welterbe",
          intro: "Das größte noch in Betrieb befindliche Dampfschöpfwerk der Welt. Ein beeindruckendes Stück niederländische Wasserbaukunst, direkt bei Lemmer.",
        },
        dok: {
          title: "Het Dok",
          tag: "Historisches Zentrum",
          intro: "Das lebendige Herz von Lemmer mit Schleuse, Terrassen und Booten. Setzen Sie sich mit einer Tasse Kaffee und sehen Sie den Schiffen zu.",
        },
        watersport: {
          title: "Wassersport auf dem IJsselmeer",
          tag: "Am Wasser",
          intro: "Segeln, SUP oder ein Tag auf dem Wasser. Lemmer ist der Ausgangspunkt für Wassersport auf dem IJsselmeer und den friesischen Seen.",
        },
      },
    },
    agenda: {
      eyebrow: "Veranstaltungen",
      title: "Was ist los?",
      intro: "Die nächsten Events in Lemmer. Notieren Sie sie schon mal.",
    },
    cta: {
      badge: "Für Unternehmer",
      title1: "Unternehmer in Lemmer?",
      title2: "Zeigen Sie Ihr Unternehmen auf Lemmer Leeft.",
      body: "Stellen Sie Ihr Unternehmen bei Einwohnern, Besuchern, Wassersportlern und Urlaubern in den Vordergrund. Melden Sie sich an und zeigen Sie, was Sie in Lemmer machen.",
      button: "Ihr Unternehmen anmelden",
    },
    seo: {
      title: "Lemmer Leeft — Entdecken Sie, was Lemmer zu bieten hat",
      description: "Das Online-Besucherportal von Lemmer. Entdecken Sie Essen & Trinken, Geschäfte, Wassersport, Veranstaltungen und mehr in diesem friesischen Wassersportdorf.",
    },
  },
  en: {
    hero: {
      eyebrow: "On the IJsselmeer · Friesland",
      title: "Welcome to Lemmer",
      subtitle: "Discover everything Lemmer has to offer.",
      ctaTodo: "What's on?",
      ctaGuide: "Browse the directory",
    },
    intro: {
      eyebrow: "Our watersports village",
      title: "Lemmer, on the water",
      p1: "On the water, with a cosy centre and world-famous heritage: there's more to experience in Lemmer than you might think. Whether you moor in the harbour, stroll along the waterfront for a day or stay nearby for longer, you'll feel welcome here.",
      p2: "From a boat trip on the water to a visit to the World Heritage Woudagemaal: in Lemmer you experience Friesland at its best. Welcome to us.",
    },
    categories: {
      eyebrow: "Discover Lemmer",
      title: "Where to begin?",
      intro: "Pick a category and dive in. From a bite to eat to a day on the water.",
      items: {
        "eten-drinken": { title: "Food & Drink", intro: "Terraces, fish restaurants and cosy cafés" },
        winkelen: { title: "Shopping", intro: "Charming shops in the centre" },
        mode: { title: "Fashion", intro: "Boutiques, shoes and accessories" },
        "wonen-interieur": { title: "Home & Interior", intro: "Inspiration for your home — furniture and décor" },
        "gezondheid-beauty": { title: "Health & Beauty", intro: "Hair, wellness and self-care" },
        diensten: { title: "Services", intro: "Skilled trades and business services" },
        overnachten: { title: "Stay", intro: "Hotels, B&Bs, campsites and holiday homes" },
        "cultuur-vrije-tijd": { title: "Culture & Leisure", intro: "Museums, activities and events" },
      },
    },
    highlights: {
      eyebrow: "Highlighted",
      title: "Not to be missed in Lemmer",
      items: {
        woudagemaal: {
          title: "Woudagemaal",
          tag: "UNESCO World Heritage",
          intro: "The largest working steam pumping station in the world. An impressive piece of Dutch water engineering, right next to Lemmer.",
        },
        dok: {
          title: "Het Dok",
          tag: "Historic centre",
          intro: "The lively heart of Lemmer with lock, terraces and boats. Sit down with a coffee and watch the ships pass by.",
        },
        watersport: {
          title: "Watersports on the IJsselmeer",
          tag: "On the water",
          intro: "Sailing, SUP or a day on the water. Lemmer is the base for watersports on the IJsselmeer and the Frisian lakes.",
        },
      },
    },
    agenda: {
      eyebrow: "Events",
      title: "What's on?",
      intro: "The next events in Lemmer. Save the dates.",
    },
    cta: {
      badge: "For businesses",
      title1: "Run a business in Lemmer?",
      title2: "Showcase your business on Lemmer Leeft.",
      body: "Put your business on the map for residents, visitors, watersports lovers and holidaymakers. Sign up and show what you do in Lemmer.",
      button: "List your business",
    },
    seo: {
      title: "Lemmer Leeft — Discover everything Lemmer has to offer",
      description: "The online visitor portal for Lemmer. Discover food & drink, shops, watersports, events and more in this Frisian watersports village.",
    },
  },
};

const woudagemaal = {
  nl: {
    seo: {
      title: "Woudagemaal Lemmer — UNESCO Werelderfgoed en het grootste stoomgemaal ter wereld",
      description: "Bezoek het Woudagemaal bij Lemmer: het grootste nog werkende stoomgemaal ter wereld en UNESCO Werelderfgoed. Ontdek dit indrukwekkende stukje Friesland.",
    },
    heroBadge: "UNESCO Werelderfgoed",
    h1: "Het Woudagemaal",
    intro: [
      "Vlak bij Lemmer staat een van de bijzonderste bouwwerken van Nederland: het Ir. D.F. Woudagemaal. Het is het grootste nog werkende stoomgemaal ter wereld, en sinds 1998 staat het op de Werelderfgoedlijst van UNESCO.",
      "Wie binnenstapt, voelt meteen de kracht van een machine die al ruim honderd jaar het water van Friesland de baas is. Een must-see als je in Lemmer bent.",
    ],
    waarom: {
      eyebrow: "Historie",
      title: "Waarom het zo bijzonder is",
      body: [
        "Het gemaal opende in 1920 en werd genoemd naar ir. Dirk Frederik Wouda, de ingenieur die het ontwierp. De taak is simpel maar levensbelangrijk: overtollig water uit Friesland wegpompen als het te hoog komt te staan.",
        "Het mooie is dat het gemaal nog echt in bedrijf is. Een paar keer per jaar, bij hoogwater, worden de ketels opgestookt en komen de reusachtige stoommachines weer tot leven. Dan doet dit eeuwenoude systeem precies waarvoor het gebouwd is.",
      ],
    },
    watJeZiet: {
      eyebrow: "Ter plekke",
      title: "Wat je ziet en beleeft",
      body: [
        "In het bezoekerscentrum ontdek je het verhaal achter het gemaal: de strijd tegen het water, de techniek en de mensen die het draaiende houden. Daarna loop je de machinehal in, waar de glimmende machines en de enorme vliegwielen indruk maken op jong en oud.",
        "Heb je geluk en staat het gemaal onder stoom tijdens je bezoek? Dan hoor en voel je pas echt hoe krachtig het is.",
      ],
      note: "Info over rondleidingen en stookdagen volgt",
    },
    goedOmTeWeten: {
      eyebrow: "Praktisch",
      title: "Goed om te weten",
      waar: { label: "Waar", value: "Ir. D.F. Woudagemaal, bij Lemmer (Tacozijl). ", placeholder: "Exact adres wordt bevestigd" },
      openingstijden: { label: "Openingstijden", placeholder: "Info volgt" },
      entree: { label: "Entree", placeholder: "Info volgt" },
      bezoekerscentrum: { label: "Bezoekerscentrum", value: "Met tentoonstelling en informatie over het gemaal." },
      hoeErKomen: { label: "Hoe kom je er", value: "Vanuit het centrum van Lemmer met de auto of fiets goed te doen. ", placeholder: "Parkeren, afstand en route volgen" },
    },
    combineer: {
      eyebrow: "Combineer",
      title: "Maak er een mooie dag van",
      body: "Combineer je bezoek met de rest van Lemmer. Na het Woudagemaal strijk je zo neer op een terras aan het water in het centrum, of je verkent de gezellige haven.",
    },
  },
  de: {
    seo: {
      title: "Woudagemaal Lemmer — UNESCO-Welterbe und das größte Dampfschöpfwerk der Welt",
      description: "Besuchen Sie das Woudagemaal bei Lemmer: das größte noch in Betrieb befindliche Dampfschöpfwerk der Welt und UNESCO-Welterbe. Entdecken Sie dieses beeindruckende Stück Friesland.",
    },
    heroBadge: "UNESCO-Welterbe",
    h1: "Das Woudagemaal",
    intro: [
      "Direkt bei Lemmer steht eines der besondersten Bauwerke der Niederlande: das Ir. D.F. Woudagemaal. Es ist das größte noch in Betrieb befindliche Dampfschöpfwerk der Welt und steht seit 1998 auf der UNESCO-Welterbeliste.",
      "Wer eintritt, spürt sofort die Kraft einer Maschine, die seit über hundert Jahren das Wasser Frieslands beherrscht. Ein Muss, wenn Sie in Lemmer sind.",
    ],
    waarom: {
      eyebrow: "Geschichte",
      title: "Warum es so besonders ist",
      body: [
        "Das Schöpfwerk wurde 1920 eröffnet und nach Ir. Dirk Frederik Wouda benannt, dem Ingenieur, der es entwarf. Seine Aufgabe ist einfach, aber lebenswichtig: überschüssiges Wasser aus Friesland abzupumpen, wenn es zu hoch steht.",
        "Das Schöne daran: Das Schöpfwerk ist noch wirklich in Betrieb. Ein paar Mal im Jahr, bei Hochwasser, werden die Kessel angeheizt und die riesigen Dampfmaschinen erwachen wieder zum Leben.",
      ],
    },
    watJeZiet: {
      eyebrow: "Vor Ort",
      title: "Was Sie sehen und erleben",
      body: [
        "Im Besucherzentrum entdecken Sie die Geschichte des Schöpfwerks: den Kampf gegen das Wasser, die Technik und die Menschen, die es am Laufen halten. Danach betreten Sie die Maschinenhalle, wo die glänzenden Maschinen und die enormen Schwungräder Jung und Alt beeindrucken.",
        "Haben Sie Glück und das Schöpfwerk steht während Ihres Besuchs unter Dampf? Dann hören und spüren Sie erst richtig, wie kraftvoll es ist.",
      ],
      note: "Infos zu Führungen und Dampftagen folgen",
    },
    goedOmTeWeten: {
      eyebrow: "Praktisches",
      title: "Gut zu wissen",
      waar: { label: "Wo", value: "Ir. D.F. Woudagemaal, bei Lemmer (Tacozijl). ", placeholder: "Genaue Adresse wird bestätigt" },
      openingstijden: { label: "Öffnungszeiten", placeholder: "Folgt in Kürze" },
      entree: { label: "Eintritt", placeholder: "Folgt in Kürze" },
      bezoekerscentrum: { label: "Besucherzentrum", value: "Mit Ausstellung und Informationen zum Schöpfwerk." },
      hoeErKomen: { label: "Anfahrt", value: "Vom Zentrum Lemmer gut mit Auto oder Fahrrad zu erreichen. ", placeholder: "Parken, Entfernung und Route folgen" },
    },
    combineer: {
      eyebrow: "Kombinieren",
      title: "Machen Sie einen schönen Tag daraus",
      body: "Verbinden Sie Ihren Besuch mit dem Rest von Lemmer. Nach dem Woudagemaal setzen Sie sich auf eine Terrasse am Wasser im Zentrum oder erkunden den gemütlichen Hafen.",
    },
  },
  en: {
    seo: {
      title: "Woudagemaal Lemmer — UNESCO World Heritage and the largest steam pumping station in the world",
      description: "Visit the Woudagemaal near Lemmer: the largest working steam pumping station in the world and a UNESCO World Heritage Site. Discover this impressive piece of Friesland.",
    },
    heroBadge: "UNESCO World Heritage",
    h1: "The Woudagemaal",
    intro: [
      "Just outside Lemmer stands one of the most remarkable buildings in the Netherlands: the Ir. D.F. Woudagemaal. It is the largest working steam pumping station in the world, and it has been on the UNESCO World Heritage List since 1998.",
      "Step inside and you immediately feel the power of a machine that has kept Friesland's water in check for over a hundred years. A must-see when you're in Lemmer.",
    ],
    waarom: {
      eyebrow: "History",
      title: "Why it's so special",
      body: [
        "The pumping station opened in 1920 and was named after Ir. Dirk Frederik Wouda, the engineer who designed it. Its job is simple but vital: to pump excess water out of Friesland when levels get too high.",
        "The best part is that the station is still genuinely in use. A few times a year, when water is high, the boilers are fired up and the enormous steam engines come to life again.",
      ],
    },
    watJeZiet: {
      eyebrow: "On site",
      title: "What you'll see and experience",
      body: [
        "In the visitor centre you'll discover the story behind the station: the battle against the water, the engineering and the people who keep it running. Then you step into the machine hall, where the gleaming machines and huge flywheels impress young and old alike.",
        "If you're lucky and the station is under steam during your visit, that's when you truly hear and feel how powerful it is.",
      ],
      note: "Info on tours and steam days coming soon",
    },
    goedOmTeWeten: {
      eyebrow: "Practical",
      title: "Good to know",
      waar: { label: "Where", value: "Ir. D.F. Woudagemaal, near Lemmer (Tacozijl). ", placeholder: "Exact address to be confirmed" },
      openingstijden: { label: "Opening hours", placeholder: "Coming soon" },
      entree: { label: "Admission", placeholder: "Coming soon" },
      bezoekerscentrum: { label: "Visitor centre", value: "With exhibition and information about the station." },
      hoeErKomen: { label: "Getting there", value: "Easy to reach from Lemmer centre by car or bike. ", placeholder: "Parking, distance and route to follow" },
    },
    combineer: {
      eyebrow: "Combine",
      title: "Make a day of it",
      body: "Combine your visit with the rest of Lemmer. After the Woudagemaal, settle on a waterside terrace in the centre or explore the lively harbour.",
    },
  },
};

const watersport = {
  nl: {
    seo: {
      title: "Watersport & Haven in Lemmer — aanmeren, jachthavens en voorzieningen",
      description: "Alles voor watersporters in Lemmer: aanmeren vanaf het IJsselmeer, jachthavens, voorzieningen en de korte weg van de haven naar het gezellige centrum.",
    },
    heroEyebrow: "Aan het water",
    h1: "Watersport & Haven",
    intro: "Lemmer is een geliefde bestemming voor watersporters. Vanaf het IJsselmeer vaar je zo de haven in, en vanaf de kade sta je binnen een paar minuten in het gezellige centrum. Aanmeren, even bijtanken en genieten: het kan hier allemaal.",
    cards: {
      aanmeren: {
        title: "Aanmeren en jachthavens",
        body: "Lemmer heeft meerdere jachthavens en aanlegplekken, van passantenplaatsen tot vaste ligplaatsen. Kom je vanaf het IJsselmeer? Dan vaar je via de Lemstersluis het dorp in.",
        placeholder: "Namen, ligplaatsen, tarieven en contact volgen",
      },
      voorzieningen: {
        title: "Voorzieningen",
        body: "In en rond de haven vind je wat je onderweg nodig hebt, zodat je snel weer klaar ligt voor de volgende tocht.",
        placeholder: "Water, stroom, brandstof, sanitair en scheepswinkel worden aangevuld",
      },
      botenverhuur: {
        title: "Botenverhuur en het water op",
        body: "Geen eigen boot? Ook dan kun je het water op.",
        placeholder: "Botenverhuur, sloepverhuur en zeilscholen volgen",
      },
      dorp: {
        title: "Van de haven zo het dorp in",
        body: "Het mooie van Lemmer: de haven en het centrum liggen vlak bij elkaar. Je meert aan en loopt zo naar een terras aan het water, een restaurant of de winkels. Even boodschappen doen of uit eten is nooit ver.",
      },
    },
  },
  de: {
    seo: {
      title: "Wassersport & Hafen in Lemmer — Anlegen, Yachthäfen und Einrichtungen",
      description: "Alles für Wassersportler in Lemmer: Anlegen am IJsselmeer, Yachthäfen, Einrichtungen und der kurze Weg vom Hafen ins gemütliche Zentrum.",
    },
    heroEyebrow: "Am Wasser",
    h1: "Wassersport & Hafen",
    intro: "Lemmer ist ein beliebtes Ziel für Wassersportler. Vom IJsselmeer fahren Sie direkt in den Hafen, und von der Kaimauer stehen Sie in wenigen Minuten im gemütlichen Zentrum. Anlegen, kurz auftanken und genießen: Hier ist alles möglich.",
    cards: {
      aanmeren: {
        title: "Anlegen und Yachthäfen",
        body: "Lemmer hat mehrere Yachthäfen und Liegeplätze, von Gastliegeplätzen bis zu festen Plätzen. Kommen Sie vom IJsselmeer? Dann fahren Sie über die Lemstersluis ins Dorf.",
        placeholder: "Namen, Liegeplätze, Preise und Kontakt folgen",
      },
      voorzieningen: {
        title: "Einrichtungen",
        body: "Im und rund um den Hafen finden Sie, was Sie unterwegs brauchen, sodass Sie schnell wieder für die nächste Tour bereit sind.",
        placeholder: "Wasser, Strom, Kraftstoff, Sanitär und Bootsladen werden ergänzt",
      },
      botenverhuur: {
        title: "Bootsverleih und aufs Wasser",
        body: "Kein eigenes Boot? Auch dann können Sie aufs Wasser.",
        placeholder: "Bootsverleih, Sloop-Verleih und Segelschulen folgen",
      },
      dorp: {
        title: "Vom Hafen direkt ins Dorf",
        body: "Das Schöne an Lemmer: Hafen und Zentrum liegen dicht beieinander. Sie legen an und gehen direkt zu einer Terrasse am Wasser, einem Restaurant oder den Geschäften.",
      },
    },
  },
  en: {
    seo: {
      title: "Watersports & Harbour in Lemmer — mooring, marinas and facilities",
      description: "Everything for watersports lovers in Lemmer: mooring on the IJsselmeer, marinas, facilities and the short walk from the harbour to the cosy centre.",
    },
    heroEyebrow: "On the water",
    h1: "Watersports & Harbour",
    intro: "Lemmer is a popular destination for watersports lovers. From the IJsselmeer you sail straight into the harbour, and from the quay you're in the cosy centre within minutes. Moor, top up your supplies and enjoy: it's all possible here.",
    cards: {
      aanmeren: {
        title: "Mooring and marinas",
        body: "Lemmer has several marinas and moorings, from visitor berths to permanent places. Arriving from the IJsselmeer? You sail into the village through the Lemstersluis.",
        placeholder: "Names, berths, rates and contacts to follow",
      },
      voorzieningen: {
        title: "Facilities",
        body: "In and around the harbour you'll find what you need along the way, so you're soon ready for the next trip.",
        placeholder: "Water, electricity, fuel, sanitary and chandlery to be added",
      },
      botenverhuur: {
        title: "Boat hire and getting on the water",
        body: "No boat of your own? You can still get on the water.",
        placeholder: "Boat hire, sloop hire and sailing schools to follow",
      },
      dorp: {
        title: "From the harbour straight into the village",
        body: "The great thing about Lemmer: the harbour and the centre are close together. You moor and walk straight to a waterside terrace, a restaurant or the shops.",
      },
    },
  },
};

const zienEnDoen = {
  nl: {
    seo: {
      title: "Zien & Doen in Lemmer — bezienswaardigheden, musea en activiteiten",
      description: "Ontdek wat er te zien en te doen is in Lemmer: het Woudagemaal (UNESCO Werelderfgoed), de Lemstersluis, bijzondere musea en activiteiten voor het hele gezin.",
    },
    eyebrow: "Ontdek Lemmer",
    h1: "Zien & Doen in Lemmer",
    intro: "Lemmer heeft voor ieder wat wils. Van wereldberoemd erfgoed tot verrassende musea en een haven waar altijd iets te beleven valt. Hieronder vind je de mooiste plekken en de leukste dingen om te doen, of je nu een paar uur blijft of een hele dag.",
    bezienswaardigheden: { eyebrow: "Overzicht", title: "Bezienswaardigheden" },
    musea: { eyebrow: "Op afspraak", title: "Musea" },
    activiteiten: {
      eyebrow: "Wat past bij je dag?",
      title: "Activiteiten",
      intro: "Op zoek naar iets specifieks? Kies wat bij je dag past.",
      filters: { "met-kinderen": "Met kinderen", "bij-regen": "Bij regen", gratis: "Gratis" },
    },
    items: {
      woudagemaal: "Het grootste nog werkende stoomgemaal ter wereld en UNESCO Werelderfgoed, net buiten Lemmer. Dé topper om te zien.",
      lemstersluis: "De karakteristieke sluis midden in het dorp, waar boten vanaf het IJsselmeer Lemmer in varen. Een van de gezelligste plekken om naar de scheepvaart te kijken.",
      dok: "Het bruisende hart van Lemmer aan het water, met terrassen, winkels en uitzicht op de boten.",
      kerk: "De markante kerktoren die je overal in Lemmer ziet, een echt herkenningspunt van het dorp.",
      vuurtoren: "Bij de haven staat een moderne vuurtoren, een open stalen baken uit 1994. Van binnen niet te bezoeken, maar mooi om te zien vanaf de kade.",
      duikmuseum: "Een bijzondere collectie over de geschiedenis van het duiken, van de eerste duikpakken tot moderne apparatuur. Bezoek op afspraak.",
      indian: "Meer dan 40 Indian-motoren uit de eerste helft van de vorige eeuw, met accessoires en verhalen. Voor liefhebbers een unieke plek. Bezoek op afspraak.",
      oudheidskamer: "Ontdek het vissersverleden van Lemmer en hoe het leven hier vroeger was.",
      "bij-regen": "Het Woudagemaal, de musea (op afspraak), of lekker schuilen op een overdekt terras.",
      gratis: "Wandelen langs de haven en het Dok, de Lemstersluis bekijken, of een rondje door het gezellige centrum.",
      kinderen: "Kijken naar de boten bij de sluis, een ijsje aan het water.",
    },
    titles: {
      woudagemaal: "Het Woudagemaal",
      lemstersluis: "De Lemstersluis",
      dok: "Het Dok",
      kerk: "Sint-Willibrorduskerk",
      vuurtoren: "De vuurtoren",
      duikmuseum: "Duikmuseum Lemmer",
      indian: "Indian Motorcycle Museum",
      oudheidskamer: "Oudheidskamer Lemmer",
      "bij-regen": "Bij regen",
      gratis: "Gratis",
      kinderen: "Met kinderen",
    },
    notes: {
      kerk: "Bezoekinfo volgt",
      musea: "Openingstijden, afspraak en entree volgen",
      oudheidskamer: "Adres, openingstijden en entree volgen",
      kinderen: "Speeltuin, strand en kindvriendelijke uitjes volgen",
    },
    cta: "Lees meer",
    ctaEten: "Eten & Drinken",
  },
  de: {
    seo: {
      title: "Sehen & Erleben in Lemmer — Sehenswürdigkeiten, Museen und Aktivitäten",
      description: "Entdecken Sie, was es in Lemmer zu sehen und zu tun gibt: das Woudagemaal (UNESCO), die Lemstersluis, besondere Museen und Aktivitäten für die ganze Familie.",
    },
    eyebrow: "Lemmer entdecken",
    h1: "Sehen & Erleben in Lemmer",
    intro: "Lemmer hat für jeden etwas. Von weltberühmtem Erbe bis zu überraschenden Museen und einem Hafen, in dem immer etwas los ist. Hier finden Sie die schönsten Orte und die besten Dinge zum Erleben.",
    bezienswaardigheden: { eyebrow: "Übersicht", title: "Sehenswürdigkeiten" },
    musea: { eyebrow: "Nach Vereinbarung", title: "Museen" },
    activiteiten: {
      eyebrow: "Was passt zu Ihrem Tag?",
      title: "Aktivitäten",
      intro: "Suchen Sie etwas Bestimmtes? Wählen Sie, was zu Ihrem Tag passt.",
      filters: { "met-kinderen": "Mit Kindern", "bij-regen": "Bei Regen", gratis: "Kostenlos" },
    },
    items: {
      woudagemaal: "Das größte noch in Betrieb befindliche Dampfschöpfwerk der Welt und UNESCO-Welterbe, direkt bei Lemmer. Der Top-Tipp.",
      lemstersluis: "Die charakteristische Schleuse mitten im Dorf, wo Boote vom IJsselmeer nach Lemmer fahren. Einer der gemütlichsten Orte, um dem Schiffsverkehr zuzusehen.",
      dok: "Das lebendige Herz von Lemmer am Wasser, mit Terrassen, Geschäften und Blick auf die Boote.",
      kerk: "Der markante Kirchturm, ein echtes Wahrzeichen des Dorfes.",
      vuurtoren: "Am Hafen steht ein moderner Leuchtturm aus 1994. Von innen nicht zu besichtigen, aber schön anzusehen.",
      duikmuseum: "Eine besondere Sammlung zur Geschichte des Tauchens, von den ersten Tauchanzügen bis zu moderner Ausrüstung. Besuch nach Vereinbarung.",
      indian: "Mehr als 40 Indian-Motorräder aus der ersten Hälfte des vorigen Jahrhunderts, mit Zubehör und Geschichten. Besuch nach Vereinbarung.",
      oudheidskamer: "Entdecken Sie die Fischereigeschichte von Lemmer und wie das Leben hier früher war.",
      "bij-regen": "Das Woudagemaal, die Museen (nach Vereinbarung), oder eine überdachte Terrasse.",
      gratis: "Am Hafen und am Dok entlangspazieren, die Lemstersluis ansehen, durchs Zentrum bummeln.",
      kinderen: "Den Booten an der Schleuse zusehen, ein Eis am Wasser.",
    },
    titles: {
      woudagemaal: "Das Woudagemaal",
      lemstersluis: "Die Lemstersluis",
      dok: "Het Dok",
      kerk: "Sint-Willibrordus-Kirche",
      vuurtoren: "Der Leuchtturm",
      duikmuseum: "Tauchmuseum Lemmer",
      indian: "Indian Motorcycle Museum",
      oudheidskamer: "Oudheidskamer Lemmer",
      "bij-regen": "Bei Regen",
      gratis: "Kostenlos",
      kinderen: "Mit Kindern",
    },
    notes: {
      kerk: "Besuchsinfos folgen",
      musea: "Öffnungszeiten, Termin und Eintritt folgen",
      oudheidskamer: "Adresse, Öffnungszeiten und Eintritt folgen",
      kinderen: "Spielplatz, Strand und kinderfreundliche Ausflüge folgen",
    },
    cta: "Mehr erfahren",
    ctaEten: "Essen & Trinken",
  },
  en: {
    seo: {
      title: "See & Do in Lemmer — sights, museums and activities",
      description: "Discover what there is to see and do in Lemmer: the Woudagemaal (UNESCO), the Lemstersluis, unique museums and activities for the whole family.",
    },
    eyebrow: "Discover Lemmer",
    h1: "See & Do in Lemmer",
    intro: "Lemmer has something for everyone. From world-famous heritage to surprising museums and a harbour where there's always something going on. Here you'll find the finest spots and the best things to do, whether you stay a few hours or a whole day.",
    bezienswaardigheden: { eyebrow: "Overview", title: "Sights" },
    musea: { eyebrow: "By appointment", title: "Museums" },
    activiteiten: {
      eyebrow: "What suits your day?",
      title: "Activities",
      intro: "Looking for something specific? Pick what suits your day.",
      filters: { "met-kinderen": "With children", "bij-regen": "When it rains", gratis: "Free" },
    },
    items: {
      woudagemaal: "The largest working steam pumping station in the world and a UNESCO World Heritage Site, just outside Lemmer. The top sight.",
      lemstersluis: "The characteristic lock in the heart of the village, where boats pass from the IJsselmeer into Lemmer. One of the nicest spots to watch the boats.",
      dok: "The lively heart of Lemmer on the water, with terraces, shops and a view of the boats.",
      kerk: "The striking church tower, a true landmark of the village.",
      vuurtoren: "By the harbour stands a modern lighthouse from 1994. Not open inside, but lovely to see from the quay.",
      duikmuseum: "A special collection on the history of diving, from the first diving suits to modern equipment. Visits by appointment.",
      indian: "More than 40 Indian motorcycles from the first half of the last century, with accessories and stories. Visits by appointment.",
      oudheidskamer: "Discover Lemmer's fishing heritage and what life here used to be like.",
      "bij-regen": "The Woudagemaal, the museums (by appointment), or a covered terrace.",
      gratis: "Walk along the harbour and Het Dok, watch the Lemstersluis, wander through the centre.",
      kinderen: "Watch the boats at the lock, an ice cream by the water.",
    },
    titles: {
      woudagemaal: "The Woudagemaal",
      lemstersluis: "The Lemstersluis",
      dok: "Het Dok",
      kerk: "St Willibrord's Church",
      vuurtoren: "The lighthouse",
      duikmuseum: "Diving Museum Lemmer",
      indian: "Indian Motorcycle Museum",
      oudheidskamer: "Oudheidskamer Lemmer",
      "bij-regen": "When it rains",
      gratis: "Free",
      kinderen: "With children",
    },
    notes: {
      kerk: "Visit info to follow",
      musea: "Opening hours, appointment and admission to follow",
      oudheidskamer: "Address, opening hours and admission to follow",
      kinderen: "Playground, beach and family activities to follow",
    },
    cta: "Read more",
    ctaEten: "Food & Drink",
  },
};

const praktisch = {
  nl: {
    seo: {
      title: "Praktische info Lemmer — bereikbaarheid, parkeren en voorzieningen",
      description: "Handige info voor je bezoek aan Lemmer: hoe kom je er met de auto, bus of boot, waar parkeer je, welke voorzieningen vind je in het dorp, en waar huur je een fiets.",
    },
    heroEyebrow: "Handig om te weten",
    h1: "Praktische info",
    intro: "Alles wat je nodig hebt voor een fijn bezoek aan Lemmer, op een rij. Hoe je er komt, waar je parkeert en wat je in het dorp kunt vinden.",
    bereikbaarheid: { eyebrow: "Bereikbaarheid", title: "Hoe kom je in Lemmer?" },
    auto: { title: "Met de auto", body: "Lemmer is goed bereikbaar via de A6. Kom je vanaf Lelystad of Joure, neem dan afrit 17 (Lemmer). Vanaf de afrit ben je in een paar minuten in het centrum." },
    ov: { title: "Met het openbaar vervoer", body: "Lemmer heeft geen treinstation, maar is met de bus goed verbonden. Het busstation ligt vlak bij de A6 en op loopafstand van het centrum. Vanuit Heerenveen, Sneek en Emmeloord rijden dagelijks bussen naar Lemmer." },
    water: { title: "Over het water", body1: "Kom je met de boot? Vanaf het IJsselmeer vaar je via de Lemstersluis zo de haven in. Meer over aanmeren, ligplaatsen en havenvoorzieningen lees je op ", link: "Watersport & Haven" },
    parkeren: {
      eyebrow: "Auto kwijt",
      title: "Parkeren",
      body: "In de gemeente De Fryske Marren, waar Lemmer bij hoort, is parkeren gratis. Let wel op de blauwe zones in het centrum: daar heb je een parkeerschijf nodig en mag je meestal maximaal twee uur staan.",
      tipTitle: "Tip",
      tip: "Op drukke dagen (marktdag, feestweek, mooi weer) staan de terreinen bij het Dok en de haven snel vol. Parkeer dan iets verder van het centrum — je loopt binnen tien minuten naar het water.",
    },
    voorzieningen: {
      eyebrow: "In het dorp",
      title: "Voorzieningen",
      body: "Alles wat je nodig hebt tijdens je bezoek vind je centraal in het dorp: openbare toiletten, gratis wifi in de horeca, pinautomaten, een apotheek en oplaadpunten voor elektrische auto's en fietsen. Ook een AED is op meerdere plekken in het centrum aanwezig.",
      items: [
        { title: "Openbare toiletten", body: "In het centrum en bij de haven." },
        { title: "Pinautomaat & apotheek", body: "In de winkelstraten in het centrum." },
        { title: "Wifi & oplaadpunten", body: "Gratis wifi in de meeste horecagelegenheden. Oplaadpunten voor e-auto's en e-bikes vind je bij de parkeerterreinen." },
        { title: "AED", body: "Op meerdere plekken in het centrum en de haven, dag en nacht bereikbaar." },
      ],
    },
    vvv: {
      eyebrow: "Toeristische info",
      title: "Toeristische info & VVV",
      body: "Op zoek naar tips, folders of een fijn gesprek over wat je kunt doen? Op verschillende plekken in het dorp vind je toeristische informatie. Horeca en ondernemers in Lemmer weten meestal precies wat er speelt — vraag gerust naar de leukste plekjes.",
      linkText: "Bekijk ook de agenda voor evenementen",
    },
    fietsverhuur: {
      eyebrow: "Op de fiets",
      title: "Fietsverhuur",
      body: "Lemmer verken je het mooist op de fiets. Vanuit het centrum fiets je zo langs het IJsselmeer, de Lemstersluis en de omringende meren en polders. Fietsen huur je op meerdere plekken in en rond de haven, ook e-bikes.",
      linkText: "Vind een fietsverhuurder in de bedrijvengids",
    },
    plattegrond: { eyebrow: "Plattegrond", title: "Het centrum van Lemmer", body: "Zo vind je Lemmer op de kaart. De haven, het Dok en de Lemstersluis liggen allemaal binnen loopafstand." },
    ontdekMeer: {
      title: "Ontdek meer",
      zienDoen: "Zien & Doen",
      etenDrinken: "Eten & Drinken",
      watersport: "Watersport & Haven",
    },
  },
  de: {
    seo: {
      title: "Praktische Infos Lemmer — Anreise, Parken und Einrichtungen",
      description: "Praktische Infos für Ihren Besuch in Lemmer: Anreise mit Auto, Bus oder Boot, Parken, Einrichtungen im Dorf und Fahrradverleih.",
    },
    heroEyebrow: "Gut zu wissen",
    h1: "Praktische Infos",
    intro: "Alles, was Sie für einen schönen Besuch in Lemmer brauchen, auf einen Blick.",
    bereikbaarheid: { eyebrow: "Anreise", title: "Wie kommen Sie nach Lemmer?" },
    auto: { title: "Mit dem Auto", body: "Lemmer ist gut über die A6 erreichbar. Von Lelystad oder Joure nehmen Sie Ausfahrt 17 (Lemmer). Von der Ausfahrt sind Sie in wenigen Minuten im Zentrum." },
    ov: { title: "Mit öffentlichen Verkehrsmitteln", body: "Lemmer hat keinen Bahnhof, ist aber gut mit dem Bus verbunden. Der Busbahnhof liegt nahe der A6 und in Laufweite zum Zentrum. Von Heerenveen, Sneek und Emmeloord fahren täglich Busse nach Lemmer." },
    water: { title: "Über das Wasser", body1: "Vom IJsselmeer fahren Sie über die Lemstersluis in den Hafen. Mehr über Anlegen, Liegeplätze und Hafeneinrichtungen lesen Sie auf ", link: "Wassersport & Hafen" },
    parkeren: {
      eyebrow: "Parken",
      title: "Parken",
      body: "In der Gemeinde De Fryske Marren, zu der Lemmer gehört, ist das Parken kostenlos. Achten Sie auf die blauen Zonen im Zentrum: dort brauchen Sie eine Parkscheibe und dürfen meist maximal zwei Stunden stehen.",
      tipTitle: "Tipp",
      tip: "An belebten Tagen (Markttag, Festwoche, schönes Wetter) sind die Parkplätze am Dok und am Hafen schnell voll. Parken Sie dann etwas weiter vom Zentrum entfernt — Sie sind in zehn Minuten am Wasser.",
    },
    voorzieningen: {
      eyebrow: "Im Dorf",
      title: "Einrichtungen",
      body: "Alles, was Sie während Ihres Besuchs brauchen, finden Sie zentral im Dorf: öffentliche Toiletten, kostenloses WLAN in der Gastronomie, Geldautomaten, eine Apotheke und Ladepunkte für Elektroautos und Fahrräder. Auch ein AED ist an mehreren Stellen im Zentrum vorhanden.",
      items: [
        { title: "Öffentliche Toiletten", body: "Im Zentrum und am Hafen." },
        { title: "Geldautomat & Apotheke", body: "In den Einkaufsstraßen im Zentrum." },
        { title: "WLAN & Ladepunkte", body: "Kostenloses WLAN in den meisten Gastronomiebetrieben. Ladepunkte für E-Autos und E-Bikes finden Sie an den Parkplätzen." },
        { title: "AED", body: "An mehreren Stellen im Zentrum und am Hafen, Tag und Nacht erreichbar." },
      ],
    },
    vvv: {
      eyebrow: "Touristeninfo",
      title: "Touristeninfo & VVV",
      body: "Auf der Suche nach Tipps, Broschüren oder einem netten Gespräch über die Aktivitäten? An verschiedenen Stellen im Dorf finden Sie Touristeninformationen. Gastronomen und Unternehmer in Lemmer wissen meist genau, was los ist — fragen Sie ruhig nach den schönsten Plätzchen.",
      linkText: "Sehen Sie auch die Veranstaltungen im Kalender",
    },
    fietsverhuur: {
      eyebrow: "Mit dem Fahrrad",
      title: "Fahrradverleih",
      body: "Lemmer erkundet man am schönsten mit dem Fahrrad. Vom Zentrum aus radeln Sie am IJsselmeer, der Lemstersluis und durch die umliegenden Seen und Polder. Fahrräder mieten Sie an mehreren Stellen im Ort und am Hafen, auch E-Bikes.",
      linkText: "Finden Sie einen Fahrradverleih im Unternehmensverzeichnis",
    },
    plattegrond: { eyebrow: "Karte", title: "Das Zentrum von Lemmer", body: "So finden Sie Lemmer auf der Karte. Hafen, Het Dok und die Lemstersluis liegen alle in Laufweite." },
    ontdekMeer: {
      title: "Mehr entdecken",
      zienDoen: "Sehen & Erleben",
      etenDrinken: "Essen & Trinken",
      watersport: "Wassersport & Hafen",
    },
  },
  en: {
    seo: {
      title: "Practical info Lemmer — getting there, parking and facilities",
      description: "Practical info for your visit to Lemmer: how to get there by car, bus or boat, parking, facilities in the village and bike rentals.",
    },
    heroEyebrow: "Good to know",
    h1: "Practical info",
    intro: "Everything you need for a great visit to Lemmer, at a glance.",
    bereikbaarheid: { eyebrow: "Getting here", title: "How to get to Lemmer" },
    auto: { title: "By car", body: "Lemmer is easily reached via the A6. From Lelystad or Joure, take exit 17 (Lemmer). From the exit you'll be in the centre in a few minutes." },
    ov: { title: "By public transport", body: "Lemmer has no train station but is well connected by bus. The bus station is near the A6 exit and within walking distance of the centre. Buses run daily from Heerenveen, Sneek and Emmeloord." },
    water: { title: "By water", body1: "From the IJsselmeer you sail into the harbour through the Lemstersluis. Read more about mooring, berths and harbour facilities on ", link: "Watersports & Harbour" },
    parkeren: {
      eyebrow: "Parking",
      title: "Parking",
      body: "In the municipality of De Fryske Marren, which includes Lemmer, parking is free. Watch out for the blue zones in the centre: there you need a parking disc and can usually stay for a maximum of two hours.",
      tipTitle: "Tip",
      tip: "On busy days (market day, festival week, sunny weather) the car parks at Het Dok and the harbour fill up quickly. Park a little further from the centre — you'll walk to the water in ten minutes.",
    },
    voorzieningen: {
      eyebrow: "In the village",
      title: "Facilities",
      body: "Everything you need during your visit is centrally located in the village: public toilets, free wifi in cafés and restaurants, ATMs, a pharmacy and charging points for electric cars and bikes. AEDs are available at several spots in the centre.",
      items: [
        { title: "Public toilets", body: "In the centre and at the harbour." },
        { title: "ATM & pharmacy", body: "In the shopping streets in the centre." },
        { title: "Wifi & charging points", body: "Free wifi in most cafés and restaurants. Charging points for EVs and e-bikes are found at the car parks." },
        { title: "AED", body: "At several spots in the centre and the harbour, accessible day and night." },
      ],
    },
    vvv: {
      eyebrow: "Tourist info",
      title: "Tourist info & VVV",
      body: "Looking for tips, brochures or a friendly chat about what to do? Tourist information is available at various spots in the village. Cafés, restaurants and shop owners in Lemmer usually know exactly what's on — just ask them about their favourite places.",
      linkText: "Check the events calendar too",
    },
    fietsverhuur: {
      eyebrow: "By bike",
      title: "Bike rental",
      body: "Lemmer is at its best when you explore it by bike. From the centre you cycle along the IJsselmeer, the Lemstersluis and through the surrounding lakes and polders. Bike rentals — including e-bikes — are available at several locations in the village and around the harbour.",
      linkText: "Find a bike rental in the business directory",
    },
    plattegrond: { eyebrow: "Map", title: "The centre of Lemmer", body: "This is Lemmer on the map. The harbour, Het Dok and the Lemstersluis are all within walking distance." },
    ontdekMeer: {
      title: "Discover more",
      zienDoen: "See & Do",
      etenDrinken: "Food & Drink",
      watersport: "Watersports & Harbour",
    },
  },
};

const webcams = {
  nl: {
    seo: {
      title: "Webcams in Lemmer — kijk live mee in de haven",
      description: "Kijk live mee in Lemmer. Van de Lemster Toer tot het IJsselmeer: beleef de haven en het water op afstand.",
    },
    heroEyebrow: "Live meekijken",
    h1: "Webcams in Lemmer",
    intro: "Kijk live mee in Lemmer. Van de Lemster Toer tot het IJsselmeer: beleef de haven en het water op afstand.",
    playLabel: "Bekijk de livestream",
    liveBadge: "Live",
    credit: "De webcams zijn een initiatief van BIZ Lemmer",
  },
  de: {
    seo: {
      title: "Webcams in Lemmer — live dabei im Hafen",
      description: "Erleben Sie Lemmer live. Von der Lemster Toer bis zum IJsselmeer: genießen Sie den Hafen und das Wasser aus der Ferne.",
    },
    heroEyebrow: "Live dabei",
    h1: "Webcams in Lemmer",
    intro: "Erleben Sie Lemmer live. Von der Lemster Toer bis zum IJsselmeer: genießen Sie den Hafen und das Wasser aus der Ferne.",
    playLabel: "Livestream ansehen",
    liveBadge: "Live",
    credit: "Die Webcams sind eine Initiative des BIZ Lemmer",
  },
  en: {
    seo: {
      title: "Webcams in Lemmer — watch the harbour live",
      description: "Watch Lemmer live. From the Lemster Toer to the IJsselmeer: experience the harbour and the water from afar.",
    },
    heroEyebrow: "Watch live",
    h1: "Webcams in Lemmer",
    intro: "Watch Lemmer live. From the Lemster Toer to the IJsselmeer: experience the harbour and the water from afar.",
    playLabel: "Watch the livestream",
    liveBadge: "Live",
    credit: "The webcams are an initiative of BIZ Lemmer",
  },
};


const categoryIntros = {
  nl: {
    "eten-en-drinken": { heading: "Eten & Drinken in Lemmer", intro: "Trek gekregen in Lemmer? Je zit goed. Van een terrasje aan het water tot een verse lunch, een hapje to-go of een ijsje voor onderweg. Ontdek hieronder waar je in Lemmer lekker eet en drinkt." },
    winkelen: { heading: "Winkelen in Lemmer", intro: "Slenter door het gezellige centrum en ontdek de winkels van Lemmer. Mode, cadeautjes, lekkers en van alles daartussenin, allemaal om de hoek. Neem de tijd en shop lokaal." },
    diensten: { heading: "Handige adressen in Lemmer", intro: "Even praktisch. Van de kapper tot de fietsenmaker: dit zijn de handige adressen in Lemmer waar je tijdens je bezoek terecht kunt." },
    bedrijvengids: { heading: "Bedrijvengids", intro: "De complete gids met alle bedrijven in Lemmer. Doorzoek op naam of filter op categorie." },
    overnachten: { title: "Overnachten in Lemmer", subtitle: "Hotels, B&B's en pensions midden in Lemmer of vlak aan het water. Vind een plek die bij je past en boek rechtstreeks bij de eigenaar." },
    notFound: { title: "Pagina niet gevonden", subtitle: "Deze pagina bestaat niet of is verhuisd. Neem een kijkje op de homepage voor alles wat Lemmer te bieden heeft." },
    agenda: { eyebrow: "Wat is er te doen?", title: "Agenda", intro: "Van feestweken en zeilraces tot de wekelijkse markt: dit staat er in Lemmer op de planning. Terugkerende evenementen zie je altijd, eenmalige verdwijnen zodra ze voorbij zijn." },
  },
  de: {
    "eten-en-drinken": { heading: "Essen & Trinken in Lemmer", intro: "Hunger bekommen in Lemmer? Sie sind richtig hier. Von einer Terrasse am Wasser über einen frischen Lunch bis zu einem Snack für unterwegs oder einem Eis. Entdecken Sie, wo Sie in Lemmer gut essen und trinken." },
    winkelen: { heading: "Einkaufen in Lemmer", intro: "Schlendern Sie durch das gemütliche Zentrum und entdecken Sie die Geschäfte von Lemmer. Mode, Geschenke, Leckereien und vieles dazwischen, alles gleich um die Ecke. Nehmen Sie sich Zeit und kaufen Sie lokal ein." },
    diensten: { heading: "Praktische Adressen in Lemmer", intro: "Kurz praktisch. Vom Friseur bis zum Fahrradladen: Das sind die praktischen Adressen in Lemmer, an die Sie sich während Ihres Besuchs wenden können." },
    bedrijvengids: { heading: "Firmenverzeichnis", intro: "Der komplette Guide mit allen Unternehmen in Lemmer. Suchen Sie nach Namen oder filtern Sie nach Kategorie." },
    overnachten: { title: "Übernachten in Lemmer", subtitle: "Hotels, B&Bs und Pensionen mitten in Lemmer oder direkt am Wasser. Finden Sie den passenden Platz und buchen Sie direkt beim Gastgeber." },
    notFound: { title: "Seite nicht gefunden", subtitle: "Diese Seite existiert nicht oder wurde verschoben. Werfen Sie einen Blick auf die Startseite für alles, was Lemmer zu bieten hat." },
    agenda: { eyebrow: "Was ist los?", title: "Veranstaltungen", intro: "Von Festwochen und Segelrennen bis zum Wochenmarkt: Das steht in Lemmer auf dem Programm. Wiederkehrende Veranstaltungen sehen Sie immer, einmalige verschwinden, sobald sie vorbei sind." },
  },
  en: {
    "eten-en-drinken": { heading: "Food & Drink in Lemmer", intro: "Feeling hungry in Lemmer? You're in the right place. From a waterside terrace to a fresh lunch, a snack to go or an ice cream. Discover where to eat and drink well in Lemmer." },
    winkelen: { heading: "Shopping in Lemmer", intro: "Stroll through the cosy centre and discover the shops of Lemmer. Fashion, gifts, treats and plenty in between, all just around the corner. Take your time and shop local." },
    diensten: { heading: "Handy addresses in Lemmer", intro: "Quick and practical. From the hairdresser to the bike shop: these are the handy addresses in Lemmer you can turn to during your visit." },
    bedrijvengids: { heading: "Business directory", intro: "The complete guide to all businesses in Lemmer. Search by name or filter by category." },
    overnachten: { title: "Stay in Lemmer", subtitle: "Hotels, B&Bs and guesthouses in the heart of Lemmer or right by the water. Find the perfect spot and book directly with the host." },
    notFound: { title: "Page not found", subtitle: "This page does not exist or has moved. Take a look at the home page for everything Lemmer has to offer." },
    agenda: { eyebrow: "What's on?", title: "Events", intro: "From festival weeks and sailing races to the weekly market: this is what's coming up in Lemmer. Recurring events are always shown; one-off events disappear once they've passed." },
  },
};

export const pageContent = {
  home,
  woudagemaal,
  watersport,
  zienEnDoen,
  praktisch,
  webcams,
  categoryIntros,
};

// Hook helper — pick current lang content for a page, with NL fallback.
export const pickLang = (obj, lang) => (obj && (obj[lang] || obj.nl)) || {};
